import { Plan } from '@/src/components/desktop/srp/fareFamily/types'
import useFormatCurrencyForSrp from "@/src/hooks/currency/useFormatCurrencyForSrp"
import { useGetRTSolutionCardData } from "@/src/hooks/srp/RTSolutionView/getRTSolutionCardData"
import { FlightCard } from '@/src/types/flight'
import { Box, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { useMemo } from "react"

export const SelectedOnwardLegPricingLabel = ({ onwardFlightData,
    selectedOnwardFareFamilyPlan }: {
        onwardFlightData: FlightCard
        selectedOnwardFareFamilyPlan: Plan | null
    }) => {

    const tCommon = useTranslations('common')
    const { formatCurrency } = useFormatCurrencyForSrp()
    const flightData = useGetRTSolutionCardData(onwardFlightData)
    const price = selectedOnwardFareFamilyPlan?.price || flightData.price
    const showStrikeOffPrice = useMemo(() => {
        return !selectedOnwardFareFamilyPlan || selectedOnwardFareFamilyPlan?.ctBrandName == 'Regular'
    }, [selectedOnwardFareFamilyPlan])
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: 2,
                py: 1,
                borderBottom: "0.5px solid #E0E0E0",

            }}
        >
            <Typography
                sx={{
                    color: '#000',
                    fontSize: '12px',
                    fontWeight: 500
                }}
            >
                {tCommon('roundTripTotalPrice')}
            </Typography>
            <Box display="flex" alignItems="center" gap={0.5}>
                {showStrikeOffPrice && flightData.strikeOffPrice && (
                    <Typography
                        sx={{
                            color: 'grey.500',
                            fontWeight: 400,
                            textDecoration: 'line-through',
                            fontSize: '11px'
                        }}
                    >
                        {formatCurrency(flightData.strikeOffPrice)}
                    </Typography>
                )}
                <Typography
                    sx={{
                        color: 'text.primary',
                        fontWeight: 700,
                        fontSize: '12px',
                        lineHeight: '16px'
                    }}
                >
                    {formatCurrency(price)}
                </Typography>
            </Box>
        </Box>
    )
}
